"use strict";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var msRest = require("ms-rest-js");
var Mappers = require("../models/mappers");
var WebResource = msRest.WebResource;
/** Class representing a SharedImages. */
var SharedImages = /*#__PURE__*/function () {
  /**
   * Create a SharedImages.
   * @param {ManagedLabsClient} client Reference to the service client.
   */
  function SharedImages(client) {
    _classCallCheck(this, SharedImages);
    this.client = client;
  }
  /**
   * List sharedimages in a given lab account.
   *
   * @param {string} resourceGroupName The name of the resource group.
   *
   * @param {string} labAccountName The name of the lab Account.
   *
   * @param {SharedImagesListOptionalParams} [options] Optional Parameters.
   *
   * @returns {Promise} A promise is returned
   *
   * @resolve {HttpOperationResponse} - The deserialized result object.
   *
   * @reject {Error|ServiceError} - The error object.
   */
  return _createClass(SharedImages, [{
    key: "listWithHttpOperationResponse",
    value: function listWithHttpOperationResponse(resourceGroupName, labAccountName, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var client, expand, filter, top, orderby, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper, deserializationError;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              client = this.client;
              expand = options && options.expand !== undefined ? options.expand : undefined;
              filter = options && options.filter !== undefined ? options.filter : undefined;
              top = options && options.top !== undefined ? options.top : undefined;
              orderby = options && options.orderby !== undefined ? options.orderby : undefined; // Validate
              _context.prev = 5;
              if (!(this.client.subscriptionId === null || this.client.subscriptionId === undefined || typeof this.client.subscriptionId.valueOf() !== 'string')) {
                _context.next = 8;
                break;
              }
              throw new Error('this.client.subscriptionId cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(resourceGroupName === null || resourceGroupName === undefined || typeof resourceGroupName.valueOf() !== 'string')) {
                _context.next = 10;
                break;
              }
              throw new Error('resourceGroupName cannot be null or undefined and it must be of type string.');
            case 10:
              if (!(labAccountName === null || labAccountName === undefined || typeof labAccountName.valueOf() !== 'string')) {
                _context.next = 12;
                break;
              }
              throw new Error('labAccountName cannot be null or undefined and it must be of type string.');
            case 12:
              if (!(expand !== null && expand !== undefined && typeof expand.valueOf() !== 'string')) {
                _context.next = 14;
                break;
              }
              throw new Error('expand must be of type string.');
            case 14:
              if (!(filter !== null && filter !== undefined && typeof filter.valueOf() !== 'string')) {
                _context.next = 16;
                break;
              }
              throw new Error('filter must be of type string.');
            case 16:
              if (!(top !== null && top !== undefined && typeof top !== 'number')) {
                _context.next = 18;
                break;
              }
              throw new Error('top must be of type number.');
            case 18:
              if (!(orderby !== null && orderby !== undefined && typeof orderby.valueOf() !== 'string')) {
                _context.next = 20;
                break;
              }
              throw new Error('orderby must be of type string.');
            case 20:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context.next = 22;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 22:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context.next = 24;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 24:
              _context.next = 29;
              break;
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](5);
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 29:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labaccounts/{labAccountName}/sharedimages';
              requestUrl = requestUrl.replace('{subscriptionId}', encodeURIComponent(this.client.subscriptionId));
              requestUrl = requestUrl.replace('{resourceGroupName}', encodeURIComponent(resourceGroupName));
              requestUrl = requestUrl.replace('{labAccountName}', encodeURIComponent(labAccountName));
              queryParamsArray = [];
              if (expand !== null && expand !== undefined) {
                queryParamsArray.push('$expand=' + encodeURIComponent(expand));
              }
              if (filter !== null && filter !== undefined) {
                queryParamsArray.push('$filter=' + encodeURIComponent(filter));
              }
              if (top !== null && top !== undefined) {
                queryParamsArray.push('$top=' + encodeURIComponent(top.toString()));
              }
              if (orderby !== null && orderby !== undefined) {
                queryParamsArray.push('$orderby=' + encodeURIComponent(orderby));
              }
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'GET';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context.prev = 50;
              _context.next = 53;
              return client.pipeline(httpRequest);
            case 53:
              operationRes = _context.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context.next = 72;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context.prev = 62;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context.next = 71;
              break;
            case 67:
              _context.prev = 67;
              _context.t1 = _context["catch"](62);
              error.message = "Error \"".concat(_context.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context.abrupt("return", Promise.reject(error));
            case 71:
              return _context.abrupt("return", Promise.reject(error));
            case 72:
              if (!(statusCode === 200)) {
                _context.next = 84;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context.prev = 74;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper = Mappers.ResponseWithContinuationSharedImage;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context.next = 84;
              break;
            case 78:
              _context.prev = 78;
              _context.t2 = _context["catch"](74);
              deserializationError = new msRest.RestError("Error ".concat(_context.t2, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context.abrupt("return", Promise.reject(deserializationError));
            case 84:
              _context.next = 89;
              break;
            case 86:
              _context.prev = 86;
              _context.t3 = _context["catch"](50);
              return _context.abrupt("return", Promise.reject(_context.t3));
            case 89:
              return _context.abrupt("return", Promise.resolve(operationRes));
            case 90:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 26], [50, 86], [62, 67], [74, 78]]);
      }));
    }
    /**
     * Get sharedimage
     *
     * @param {string} resourceGroupName The name of the resource group.
     *
     * @param {string} labAccountName The name of the lab Account.
     *
     * @param {string} sharedImageName The name of the sharedImage.
     *
     * @param {SharedImagesGetOptionalParams} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "getWithHttpOperationResponse",
    value: function getWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var client, expand, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper2, deserializationError;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              client = this.client;
              expand = options && options.expand !== undefined ? options.expand : undefined; // Validate
              _context2.prev = 2;
              if (!(this.client.subscriptionId === null || this.client.subscriptionId === undefined || typeof this.client.subscriptionId.valueOf() !== 'string')) {
                _context2.next = 5;
                break;
              }
              throw new Error('this.client.subscriptionId cannot be null or undefined and it must be of type string.');
            case 5:
              if (!(resourceGroupName === null || resourceGroupName === undefined || typeof resourceGroupName.valueOf() !== 'string')) {
                _context2.next = 7;
                break;
              }
              throw new Error('resourceGroupName cannot be null or undefined and it must be of type string.');
            case 7:
              if (!(labAccountName === null || labAccountName === undefined || typeof labAccountName.valueOf() !== 'string')) {
                _context2.next = 9;
                break;
              }
              throw new Error('labAccountName cannot be null or undefined and it must be of type string.');
            case 9:
              if (!(sharedImageName === null || sharedImageName === undefined || typeof sharedImageName.valueOf() !== 'string')) {
                _context2.next = 11;
                break;
              }
              throw new Error('sharedImageName cannot be null or undefined and it must be of type string.');
            case 11:
              if (!(expand !== null && expand !== undefined && typeof expand.valueOf() !== 'string')) {
                _context2.next = 13;
                break;
              }
              throw new Error('expand must be of type string.');
            case 13:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context2.next = 15;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 15:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context2.next = 17;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 17:
              _context2.next = 22;
              break;
            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](2);
              return _context2.abrupt("return", Promise.reject(_context2.t0));
            case 22:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labaccounts/{labAccountName}/sharedimages/{sharedImageName}';
              requestUrl = requestUrl.replace('{subscriptionId}', encodeURIComponent(this.client.subscriptionId));
              requestUrl = requestUrl.replace('{resourceGroupName}', encodeURIComponent(resourceGroupName));
              requestUrl = requestUrl.replace('{labAccountName}', encodeURIComponent(labAccountName));
              requestUrl = requestUrl.replace('{sharedImageName}', encodeURIComponent(sharedImageName));
              queryParamsArray = [];
              if (expand !== null && expand !== undefined) {
                queryParamsArray.push('$expand=' + encodeURIComponent(expand));
              }
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'GET';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context2.prev = 41;
              _context2.next = 44;
              return client.pipeline(httpRequest);
            case 44:
              operationRes = _context2.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context2.next = 63;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context2.prev = 53;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context2.next = 62;
              break;
            case 58:
              _context2.prev = 58;
              _context2.t1 = _context2["catch"](53);
              error.message = "Error \"".concat(_context2.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context2.abrupt("return", Promise.reject(error));
            case 62:
              return _context2.abrupt("return", Promise.reject(error));
            case 63:
              if (!(statusCode === 200)) {
                _context2.next = 75;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context2.prev = 65;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper2 = Mappers.SharedImage;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper2, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context2.next = 75;
              break;
            case 69:
              _context2.prev = 69;
              _context2.t2 = _context2["catch"](65);
              deserializationError = new msRest.RestError("Error ".concat(_context2.t2, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context2.abrupt("return", Promise.reject(deserializationError));
            case 75:
              _context2.next = 80;
              break;
            case 77:
              _context2.prev = 77;
              _context2.t3 = _context2["catch"](41);
              return _context2.abrupt("return", Promise.reject(_context2.t3));
            case 80:
              return _context2.abrupt("return", Promise.resolve(operationRes));
            case 81:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 19], [41, 77], [53, 58], [65, 69]]);
      }));
    }
    /**
     * Create or replace an existing SharedImage.
     *
     * @param {string} resourceGroupName The name of the resource group.
     *
     * @param {string} labAccountName The name of the lab Account.
     *
     * @param {string} sharedImageName The name of the sharedImage.
     *
     * @param {SharedImage} sharedImage Represents a shared image from Shared Image
     * Gallery
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "createOrUpdateWithHttpOperationResponse",
    value: function createOrUpdateWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, sharedImage, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper3, deserializationError, _parsedResponse, _resultMapper4, deserializationError1;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              client = this.client; // Validate
              _context3.prev = 1;
              if (!(this.client.subscriptionId === null || this.client.subscriptionId === undefined || typeof this.client.subscriptionId.valueOf() !== 'string')) {
                _context3.next = 4;
                break;
              }
              throw new Error('this.client.subscriptionId cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(resourceGroupName === null || resourceGroupName === undefined || typeof resourceGroupName.valueOf() !== 'string')) {
                _context3.next = 6;
                break;
              }
              throw new Error('resourceGroupName cannot be null or undefined and it must be of type string.');
            case 6:
              if (!(labAccountName === null || labAccountName === undefined || typeof labAccountName.valueOf() !== 'string')) {
                _context3.next = 8;
                break;
              }
              throw new Error('labAccountName cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(sharedImageName === null || sharedImageName === undefined || typeof sharedImageName.valueOf() !== 'string')) {
                _context3.next = 10;
                break;
              }
              throw new Error('sharedImageName cannot be null or undefined and it must be of type string.');
            case 10:
              if (!(sharedImage === null || sharedImage === undefined)) {
                _context3.next = 12;
                break;
              }
              throw new Error('sharedImage cannot be null or undefined.');
            case 12:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context3.next = 14;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 14:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context3.next = 16;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 16:
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", Promise.reject(_context3.t0));
            case 21:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labaccounts/{labAccountName}/sharedimages/{sharedImageName}';
              requestUrl = requestUrl.replace('{subscriptionId}', encodeURIComponent(this.client.subscriptionId));
              requestUrl = requestUrl.replace('{resourceGroupName}', encodeURIComponent(resourceGroupName));
              requestUrl = requestUrl.replace('{labAccountName}', encodeURIComponent(labAccountName));
              requestUrl = requestUrl.replace('{sharedImageName}', encodeURIComponent(sharedImageName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'PUT';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context3.prev = 40;
              if (sharedImage !== null && sharedImage !== undefined) {
                requestModelMapper = Mappers.SharedImage;
                requestModel = client.serializer.serialize(requestModelMapper, sharedImage, 'sharedImage');
                requestContent = JSON.stringify(requestModel);
              }
              _context3.next = 48;
              break;
            case 44:
              _context3.prev = 44;
              _context3.t1 = _context3["catch"](40);
              serializationError = new Error("Error \"".concat(_context3.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(sharedImage, null, 2), "."));
              return _context3.abrupt("return", Promise.reject(serializationError));
            case 48:
              httpRequest.body = requestContent;
              // Send Request
              _context3.prev = 49;
              _context3.next = 52;
              return client.pipeline(httpRequest);
            case 52:
              operationRes = _context3.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200 && statusCode !== 201)) {
                _context3.next = 71;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context3.prev = 61;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context3.next = 70;
              break;
            case 66:
              _context3.prev = 66;
              _context3.t2 = _context3["catch"](61);
              error.message = "Error \"".concat(_context3.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context3.abrupt("return", Promise.reject(error));
            case 70:
              return _context3.abrupt("return", Promise.reject(error));
            case 71:
              if (!(statusCode === 200)) {
                _context3.next = 83;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context3.prev = 73;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper3 = Mappers.SharedImage;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper3, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context3.next = 83;
              break;
            case 77:
              _context3.prev = 77;
              _context3.t3 = _context3["catch"](73);
              deserializationError = new msRest.RestError("Error ".concat(_context3.t3, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context3.abrupt("return", Promise.reject(deserializationError));
            case 83:
              if (!(statusCode === 201)) {
                _context3.next = 95;
                break;
              }
              _parsedResponse = operationRes.bodyAsJson;
              _context3.prev = 85;
              if (_parsedResponse !== null && _parsedResponse !== undefined) {
                _resultMapper4 = Mappers.SharedImage;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper4, _parsedResponse, 'operationRes.bodyAsJson');
              }
              _context3.next = 95;
              break;
            case 89:
              _context3.prev = 89;
              _context3.t4 = _context3["catch"](85);
              deserializationError1 = new msRest.RestError("Error ".concat(_context3.t4, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError1.request = msRest.stripRequest(httpRequest);
              deserializationError1.response = msRest.stripResponse(response);
              return _context3.abrupt("return", Promise.reject(deserializationError1));
            case 95:
              _context3.next = 100;
              break;
            case 97:
              _context3.prev = 97;
              _context3.t5 = _context3["catch"](49);
              return _context3.abrupt("return", Promise.reject(_context3.t5));
            case 100:
              return _context3.abrupt("return", Promise.resolve(operationRes));
            case 101:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 18], [40, 44], [49, 97], [61, 66], [73, 77], [85, 89]]);
      }));
    }
    /**
     * Delete sharedimage.
     *
     * @param {string} resourceGroupName The name of the resource group.
     *
     * @param {string} labAccountName The name of the lab Account.
     *
     * @param {string} sharedImageName The name of the sharedImage.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "deleteMethodWithHttpOperationResponse",
    value: function deleteMethodWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              client = this.client; // Validate
              _context4.prev = 1;
              if (!(this.client.subscriptionId === null || this.client.subscriptionId === undefined || typeof this.client.subscriptionId.valueOf() !== 'string')) {
                _context4.next = 4;
                break;
              }
              throw new Error('this.client.subscriptionId cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(resourceGroupName === null || resourceGroupName === undefined || typeof resourceGroupName.valueOf() !== 'string')) {
                _context4.next = 6;
                break;
              }
              throw new Error('resourceGroupName cannot be null or undefined and it must be of type string.');
            case 6:
              if (!(labAccountName === null || labAccountName === undefined || typeof labAccountName.valueOf() !== 'string')) {
                _context4.next = 8;
                break;
              }
              throw new Error('labAccountName cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(sharedImageName === null || sharedImageName === undefined || typeof sharedImageName.valueOf() !== 'string')) {
                _context4.next = 10;
                break;
              }
              throw new Error('sharedImageName cannot be null or undefined and it must be of type string.');
            case 10:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context4.next = 12;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 12:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context4.next = 14;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 14:
              _context4.next = 19;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](1);
              return _context4.abrupt("return", Promise.reject(_context4.t0));
            case 19:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labaccounts/{labAccountName}/sharedimages/{sharedImageName}';
              requestUrl = requestUrl.replace('{subscriptionId}', encodeURIComponent(this.client.subscriptionId));
              requestUrl = requestUrl.replace('{resourceGroupName}', encodeURIComponent(resourceGroupName));
              requestUrl = requestUrl.replace('{labAccountName}', encodeURIComponent(labAccountName));
              requestUrl = requestUrl.replace('{sharedImageName}', encodeURIComponent(sharedImageName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'DELETE';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context4.prev = 37;
              _context4.next = 40;
              return client.pipeline(httpRequest);
            case 40:
              operationRes = _context4.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200 && statusCode !== 204)) {
                _context4.next = 59;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context4.prev = 49;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context4.next = 58;
              break;
            case 54:
              _context4.prev = 54;
              _context4.t1 = _context4["catch"](49);
              error.message = "Error \"".concat(_context4.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context4.abrupt("return", Promise.reject(error));
            case 58:
              return _context4.abrupt("return", Promise.reject(error));
            case 59:
              _context4.next = 64;
              break;
            case 61:
              _context4.prev = 61;
              _context4.t2 = _context4["catch"](37);
              return _context4.abrupt("return", Promise.reject(_context4.t2));
            case 64:
              return _context4.abrupt("return", Promise.resolve(operationRes));
            case 65:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 16], [37, 61], [49, 54]]);
      }));
    }
    /**
     * Modify properties of sharedimages.
     *
     * @param {string} resourceGroupName The name of the resource group.
     *
     * @param {string} labAccountName The name of the lab Account.
     *
     * @param {string} sharedImageName The name of the sharedImage.
     *
     * @param {SharedImageFragment} sharedImage Represents a shared image from
     * Shared Image Gallery
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "updateWithHttpOperationResponse",
    value: function updateWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, sharedImage, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper5, deserializationError;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              client = this.client; // Validate
              _context5.prev = 1;
              if (!(this.client.subscriptionId === null || this.client.subscriptionId === undefined || typeof this.client.subscriptionId.valueOf() !== 'string')) {
                _context5.next = 4;
                break;
              }
              throw new Error('this.client.subscriptionId cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(resourceGroupName === null || resourceGroupName === undefined || typeof resourceGroupName.valueOf() !== 'string')) {
                _context5.next = 6;
                break;
              }
              throw new Error('resourceGroupName cannot be null or undefined and it must be of type string.');
            case 6:
              if (!(labAccountName === null || labAccountName === undefined || typeof labAccountName.valueOf() !== 'string')) {
                _context5.next = 8;
                break;
              }
              throw new Error('labAccountName cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(sharedImageName === null || sharedImageName === undefined || typeof sharedImageName.valueOf() !== 'string')) {
                _context5.next = 10;
                break;
              }
              throw new Error('sharedImageName cannot be null or undefined and it must be of type string.');
            case 10:
              if (!(sharedImage === null || sharedImage === undefined)) {
                _context5.next = 12;
                break;
              }
              throw new Error('sharedImage cannot be null or undefined.');
            case 12:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context5.next = 14;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 14:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context5.next = 16;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 16:
              _context5.next = 21;
              break;
            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", Promise.reject(_context5.t0));
            case 21:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labaccounts/{labAccountName}/sharedimages/{sharedImageName}';
              requestUrl = requestUrl.replace('{subscriptionId}', encodeURIComponent(this.client.subscriptionId));
              requestUrl = requestUrl.replace('{resourceGroupName}', encodeURIComponent(resourceGroupName));
              requestUrl = requestUrl.replace('{labAccountName}', encodeURIComponent(labAccountName));
              requestUrl = requestUrl.replace('{sharedImageName}', encodeURIComponent(sharedImageName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'PATCH';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context5.prev = 40;
              if (sharedImage !== null && sharedImage !== undefined) {
                requestModelMapper = Mappers.SharedImageFragment;
                requestModel = client.serializer.serialize(requestModelMapper, sharedImage, 'sharedImage');
                requestContent = JSON.stringify(requestModel);
              }
              _context5.next = 48;
              break;
            case 44:
              _context5.prev = 44;
              _context5.t1 = _context5["catch"](40);
              serializationError = new Error("Error \"".concat(_context5.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(sharedImage, null, 2), "."));
              return _context5.abrupt("return", Promise.reject(serializationError));
            case 48:
              httpRequest.body = requestContent;
              // Send Request
              _context5.prev = 49;
              _context5.next = 52;
              return client.pipeline(httpRequest);
            case 52:
              operationRes = _context5.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context5.next = 71;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context5.prev = 61;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context5.next = 70;
              break;
            case 66:
              _context5.prev = 66;
              _context5.t2 = _context5["catch"](61);
              error.message = "Error \"".concat(_context5.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context5.abrupt("return", Promise.reject(error));
            case 70:
              return _context5.abrupt("return", Promise.reject(error));
            case 71:
              if (!(statusCode === 200)) {
                _context5.next = 83;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context5.prev = 73;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper5 = Mappers.SharedImage;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper5, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context5.next = 83;
              break;
            case 77:
              _context5.prev = 77;
              _context5.t3 = _context5["catch"](73);
              deserializationError = new msRest.RestError("Error ".concat(_context5.t3, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context5.abrupt("return", Promise.reject(deserializationError));
            case 83:
              _context5.next = 88;
              break;
            case 85:
              _context5.prev = 85;
              _context5.t4 = _context5["catch"](49);
              return _context5.abrupt("return", Promise.reject(_context5.t4));
            case 88:
              return _context5.abrupt("return", Promise.resolve(operationRes));
            case 89:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 18], [40, 44], [49, 85], [61, 66], [73, 77]]);
      }));
    }
    /**
     * List sharedimages in a given lab account.
     *
     * @param {string} nextPageLink The NextLink from the previous successful call
     * to List operation.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "listNextWithHttpOperationResponse",
    value: function listNextWithHttpOperationResponse(nextPageLink, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var client, requestUrl, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper6, deserializationError;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              client = this.client; // Validate
              _context6.prev = 1;
              if (!(nextPageLink === null || nextPageLink === undefined || typeof nextPageLink.valueOf() !== 'string')) {
                _context6.next = 4;
                break;
              }
              throw new Error('nextPageLink cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context6.next = 6;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 6:
              _context6.next = 11;
              break;
            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              return _context6.abrupt("return", Promise.reject(_context6.t0));
            case 11:
              // Construct URL
              requestUrl = '{nextLink}';
              requestUrl = requestUrl.replace('{nextLink}', nextPageLink);
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'GET';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context6.prev = 22;
              _context6.next = 25;
              return client.pipeline(httpRequest);
            case 25:
              operationRes = _context6.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context6.next = 44;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context6.prev = 34;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context6.next = 43;
              break;
            case 39:
              _context6.prev = 39;
              _context6.t1 = _context6["catch"](34);
              error.message = "Error \"".concat(_context6.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context6.abrupt("return", Promise.reject(error));
            case 43:
              return _context6.abrupt("return", Promise.reject(error));
            case 44:
              if (!(statusCode === 200)) {
                _context6.next = 56;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context6.prev = 46;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper6 = Mappers.ResponseWithContinuationSharedImage;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper6, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context6.next = 56;
              break;
            case 50:
              _context6.prev = 50;
              _context6.t2 = _context6["catch"](46);
              deserializationError = new msRest.RestError("Error ".concat(_context6.t2, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context6.abrupt("return", Promise.reject(deserializationError));
            case 56:
              _context6.next = 61;
              break;
            case 58:
              _context6.prev = 58;
              _context6.t3 = _context6["catch"](22);
              return _context6.abrupt("return", Promise.reject(_context6.t3));
            case 61:
              return _context6.abrupt("return", Promise.resolve(operationRes));
            case 62:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 8], [22, 58], [34, 39], [46, 50]]);
      }));
    }
  }, {
    key: "list",
    value: function list(resourceGroupName, labAccountName, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.listWithHttpOperationResponse(resourceGroupName, labAccountName, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.listWithHttpOperationResponse(resourceGroupName, labAccountName, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "get",
    value: function get(resourceGroupName, labAccountName, sharedImageName, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.getWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.getWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "createOrUpdate",
    value: function createOrUpdate(resourceGroupName, labAccountName, sharedImageName, sharedImage, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.createOrUpdateWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, sharedImage, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.createOrUpdateWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, sharedImage, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "deleteMethod",
    value: function deleteMethod(resourceGroupName, labAccountName, sharedImageName, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.deleteMethodWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.deleteMethodWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "update",
    value: function update(resourceGroupName, labAccountName, sharedImageName, sharedImage, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.updateWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, sharedImage, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.updateWithHttpOperationResponse(resourceGroupName, labAccountName, sharedImageName, sharedImage, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "listNext",
    value: function listNext(nextPageLink, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.listNextWithHttpOperationResponse(nextPageLink, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.listNextWithHttpOperationResponse(nextPageLink, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }]);
}();
exports.SharedImages = SharedImages;